const inititalState = { profileData: null,token : null };
const profileReducer = (state = inititalState, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case "SETUSERDETAILS": {
      return { ...state, profileData: action.payload };
    }
    case "SETUSERTOKEN": {
      return { ...state, token: action.payload };
    }
  }
  return state;
};

export default profileReducer;
